import { useQuery } from "@tanstack/react-query";
import { getNationalitiesForSelect } from "../../api/apiNationalities";
import i18next from "i18next";

const useGetNationalitiesForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["NationalitiesForSelect", i18next.language],
        queryFn: getNationalitiesForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetNationalitiesForSelect;
